import { signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { auth, googleProvider } from '../firebase';
import { saveUserProfile } from './firebaseDatabase';

export const loginWithGoogle = async () => {
    const result = await signInWithPopup(auth, googleProvider);

    // Get the access token for Google APIs
    const credential = GoogleAuthProvider.credentialFromResult(result);
    const accessToken = credential.accessToken;

    const user = result.user;
    const userData = {
        name: user.displayName,
        email: user.email,
        picture: user.photoURL
    };

    // Save user profile to Firebase database
    await saveUserProfile(user.uid, userData);
    console.log('✅ Signed in with Firebase, UID:', user.uid);

    return { accessToken, userData };
};

export const checkTokenValidity = async (accessToken) => {
    const testResponse = await fetch('https://www.googleapis.com/oauth2/v2/userinfo', {
        headers: { Authorization: `Bearer ${accessToken}` }
    });
    return testResponse.status !== 401;
};